import {
  CAREMAN_SEARCH, CAREMAN_SEARCH_SUCCESS, CAREMAN_SEARCH_FAILURE, CAREMAN_CLEAR,
  CAREMAN_SEARCH_AUTOCOMPLETE_SUCCESS, CAREMAN_AUTOCOMPLETE_CLEAR,
  CAREMAN_SEARCH_DETAIL, CAREMAN_SEARCH_DETAIL_FAILURE, CAREMAN_SEARCH_DETAIL_SUCCESS, CAREMAN_DETAIL_CLEAR,
  CAREMAN_EDIT, CAREMAN_EDIT_FAILURE, CAREMAN_EDIT_SUCCESS, CAREMAN_EDIT_CLEAR,
  CAREMAN_SEARCH_HISTORY, CAREMAN_SEARCH_HISTORY_FAILURE, CAREMAN_SEARCH_HISTORY_SUCCESS,
  CAREMAN_DELETE, CAREMAN_DELETE_FAILURE, CAREMAN_DELETE_SUCCESS,
  CAREMAN_DUPLICATE_CHECK, CAREMAN_DUPLICATE_CHECK_SUCCESS, CAREMAN_DUPLICATE_CHECK_FAILURE,
  CAREMAN_MSG_ALERT
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    careman: null,
    caremans: null,
    caremanHistories: null,
    caremansAutocomplete: null,
    caremansCurrentPage: null,
    caremansNextPage: null,
    caremansPrevPage: null,
    caremansTotalCount: 0,
    caremansNextPageLink: null,
    caremansSearchParams: null,
    caremanNotify: null
  },
  getters: {
    careman: state => {
      return state.careman
    },
    caremans: state => {
      return state.caremans
    },
    caremanHistories: state => {
      return state.caremanHistories
    },
    caremansAutocomplete: state => {
      return state.caremansAutocomplete
    },
    caremansCurrentPage: state => {
      return state.caremansCurrentPage
    },
    caremansNextPage: state => {
      return state.caremansNextPage
    },
    caremansPrevPage: state => {
      return state.caremansPrevPage
    },
    caremansTotalCount: state => {
      return state.caremansTotalCount
    },
    caremansNextPageLink: state => {
      return state.caremansNextPageLink
    },
    caremansSearchParams: state => {
      return state.caremansSearchParams
    },
    /** 通知 */
    caremanNotify: state => {
      return state.caremanNotify
    }
  },
  actions: {
    [CAREMAN_SEARCH] ({dispatch, state, commit}, params) {
      var url = '/caremans'
      var data = {}
      var loadparams = true
      var noneList = null
      var callback = () => {}
      if (params) {
        data = params.data
        state.caremansSearchParams = params.data
        if (params.autocomplete) {
          loadparams = false
        }
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
        if ('noneList' in params) {
          noneList = params.noneList
        }
        if ('callback' in params) {
          callback = params.callback
        }
        if (params.url) {
          url = params.url
        }
        if (params.clear) {
          state.caremans = null
          state.caremansNextPage = 0
          state.caremansTotalCount = 0
          state.caremansNextPageLink = null
          state.caremansCurrentPage = null
        }
      }
      dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CAREMAN_SEARCH_FAILURE, {data: res.data, callback: callback})
            } else {
              if (params.autocomplete) {
                commit(CAREMAN_SEARCH_AUTOCOMPLETE_SUCCESS, {data: res.data, noneList: noneList, callback: callback})
              } else {
                commit(CAREMAN_SEARCH_SUCCESS, {data: res.data, callback: callback})
              }
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [CAREMAN_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(CAREMAN_CLEAR)
      }, sleep)
    },
    [CAREMAN_DETAIL_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(CAREMAN_DETAIL_CLEAR)
      }, sleep)
    },
    [CAREMAN_EDIT_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(CAREMAN_EDIT_CLEAR)
      }, sleep)
    },
    [CAREMAN_AUTOCOMPLETE_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(CAREMAN_AUTOCOMPLETE_CLEAR)
      }, sleep)
    },
    [CAREMAN_SEARCH_DETAIL]  ({dispatch, state, commit}, params) {
      var data = params.data
      var callback = () => {}
      if (params.callback) {
        callback = params.callback
      }
      dispatch('apiGet', {url: '/caremans/' + params.caremanId, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(CAREMAN_SEARCH_DETAIL_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(CAREMAN_SEARCH_DETAIL_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [CAREMAN_SEARCH_HISTORY] ({dispatch, state, commit}, params) {
      var data = params.data
      var callback = params.callback
      dispatch('apiGet', { url: '/caremans/hist', data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(CAREMAN_SEARCH_HISTORY_FAILURE, {data: res.data, callback: callback})
          } else {
            res.data.callback = callback
            commit(CAREMAN_SEARCH_HISTORY_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [CAREMAN_EDIT]  ({dispatch, state, commit}, params) {
      var data = params.data
      var callback = params.callback
      dispatch('apiPost', {url: '/caremans', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(CAREMAN_EDIT_FAILURE, res.data)
          } else {
            commit(CAREMAN_EDIT_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [CAREMAN_DELETE]  ({dispatch, state, commit}, params) {
      var callback = params.callback
      dispatch('apiDelete', {url: '/caremans/' + params.historyId})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(CAREMAN_DELETE_FAILURE, res.data)
          } else {
            commit(CAREMAN_DELETE_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [CAREMAN_DUPLICATE_CHECK] ({dispatch, state, commit}, params) {
      var data = params.data
      var callback = params.callback
      dispatch('apiGet', {url: '/caremans/duplicate_check', data: data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(CAREMAN_DUPLICATE_CHECK_FAILURE, res.data)
          } else {
            commit(CAREMAN_DUPLICATE_CHECK_SUCCESS, { data: res.data, callback: callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [CAREMAN_MSG_ALERT] ({state, commit}, msg) {
      commit(CAREMAN_MSG_ALERT, msg)
    }
  },
  mutations: {
    [CAREMAN_SEARCH_FAILURE] (state, data) {
      console.log('CAREMAN_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [CAREMAN_SEARCH_SUCCESS] (state, params) {
      console.log('CAREMAN_SEARCH_SUCCESS')
      var data = params.data
      var reSearch = false

      state.caremansTotalCount = 0

      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }

      if (reSearch) {
        // 再検索
        state.caremans = data.data
        if (data.meta['next-page'] === null) {
          // 次へのリンクが無かったら
          state.caremansNextPage = null
        }
      } else {
        if (data.meta) {
          if (data.meta['current-page'] && data.meta['current-page'] > 1) {
            state.caremans = state.caremans.concat(data.data)
            state.caremansCurrentPage = data.meta['current-page']
          } else {
            state.caremans = data.data
            state.caremansCurrentPage = data.meta['current-page']
          }
          state.caremansNextPage = null
          if (data.meta['next-page']) {
            state.caremansNextPage = data.meta['next-page']
          }
        } else {
          state.caremans = data.data
        }
        state.caremansNextPageLink = null
        if (data.links && data.links['next']) {
          state.caremansNextPageLink = data.links['next']
        } else {
          state.caremansNextPageLink = null
        }
      }

      if (data.meta && data.meta['total-count']) {
        state.caremansTotalCount = data.meta['total-count']
      }

      if (params.callback) {
        params.callback()
      }
    },
    [CAREMAN_CLEAR] (state) {
      state.caremans = null
    },
    [CAREMAN_DETAIL_CLEAR] (state) {
      state.caremanHistories = null
    },
    [CAREMAN_EDIT_CLEAR] (state) {
      state.careman = null
    },
    [CAREMAN_SEARCH_AUTOCOMPLETE_SUCCESS] (state, param) {
      console.log('CAREMAN_SEARCH_AUTOCOMPLETE_SUCCESS')
      var data = param.data.data
      state.caremansAutocomplete = data
      // なし追加
      if (param.noneList !== null) {
        if (state.caremansAutocomplete === null) {
          state.caremansAutocomplete = []
        }
        state.caremansAutocomplete.unshift({
          'id': param.noneList['id'],
          'type': 'caremans',
          'attributes': {'careman-name': param.noneList['name'], 'careman-name-furigana': ''}
        })
      }
    },
    [CAREMAN_AUTOCOMPLETE_CLEAR] (state) {
      console.log('CAREMAN_AUTOCOMPLETE_CLEAR')
      state.caremansAutocomplete = null
    },
    [CAREMAN_SEARCH_DETAIL_FAILURE] (state, data) {
      console.log('CAREMAN_SEARCH_DETAIL_FAILURE')
      if (data.callback) {
        data.callback(null)
      }
    },
    [CAREMAN_SEARCH_DETAIL_SUCCESS] (state, params) {
      console.log('CAREMAN_SEARCH_DETAIL_SUCCESS')
      var data = params.data
      state.caremanHistories = data.data
      if (params.callback) {
        params.callback(data.data)
      }
    },
    [CAREMAN_SEARCH_HISTORY_FAILURE] (state, data) {
      console.log('CAREMAN_SEARCH_HISTORY_FAILURE')
      if (data.callback) {
        data.callback(null)
      }
    },
    [CAREMAN_SEARCH_HISTORY_SUCCESS] (state, param) {
      console.log('CAREMAN_SEARCH_HISTORY_SUCCESS')
      var data = param.data.data
      state.careman = data
      if (param.callback) {
        param.callback()
      }
    },
    [CAREMAN_EDIT_FAILURE] (state, data) {
      console.log('CAREMAN_EDIT_FAILURE')
      // 通知
      state.caremanNotify = {
        danger: true,
        message_i18n: 'messages.save.danger'
      }
      setTimeout(() => {
        state.caremanNotify = null
      }, constant.notifyShowTime.normal)
    },
    [CAREMAN_EDIT_SUCCESS] (state, param) {
      console.log('CAREMAN_EDIT_SUCCESS')
      var data = param.data.data
      state.careman = data
      if (param.callback) {
        param.callback()
      }
      // 通知
      state.caremanNotify = {
        success: true,
        message_i18n: 'messages.save.success'
      }
      setTimeout(() => {
        state.caremanNotify = null
      }, constant.notifyShowTime.normal)
    },
    [CAREMAN_DELETE_FAILURE] (state, data) {
      console.log('CAREMAN_DELETE_FAILURE')
      // 通知
      state.caremanNotify = {
        danger: true,
        message_i18n: 'messages.delete.danger'
      }
      setTimeout(() => {
        state.caremanNotify = null
      }, constant.notifyShowTime.normal)
    },
    [CAREMAN_DELETE_SUCCESS] (state, param) {
      console.log('CAREMAN_DELETE_SUCCESS')
      if (param.callback) {
        param.callback()
      }
      // 通知
      state.caremanNotify = {
        success: true,
        message_i18n: 'messages.delete.success'
      }
      setTimeout(() => {
        state.caremanNotify = null
      }, constant.notifyShowTime.normal)
    },
    [CAREMAN_DUPLICATE_CHECK_FAILURE] (state, data) {
      console.log('CAREMAN_DUPLICATE_CHECK_FAILURE')
    },
    [CAREMAN_DUPLICATE_CHECK_SUCCESS] (state, data) {
      console.log('CAREMAN_DUPLICATE_CHECK_SUCCESS')
      if (data.callback !== null) {
        data.callback(data.data)
      }
    },
    [CAREMAN_MSG_ALERT] (state, msg) {
      state.caremanNotify = msg
      setTimeout(() => { state.caremanNotify = null }, constant.notifyShowTime.normal)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/careman.js